import {Card} from 'primereact/card';
import React from 'react';
import {withTranslation} from 'react-i18next';
import NumberFormat from 'react-number-format';
import BaseListContainer from '../baseContainers/BaseListContainer';
import {CustomMessages} from '../components/CustomMessages';
import DivContainer from '../components/DivContainer';
import BlockUi from '../components/waitPanel/BlockUi';
import {baseReportCsv, baseReportPdf, baseXLSXReport} from '../report/ReportUtils';
import AccountService from '../services/AccountService';

class IncomeListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new AccountService());
        this.state = {
            list: [],
            selectedList: [],
            selectAll: false,
            loading: true,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            filters: {},
        };
    }
    onAfterGetList() {
        if (this.props.onAfterGetList) {
            this.props.onAfterGetList(this.state.list);
        } else {
            super.onAfterGetList();
        }
    }
    getList() {
        const {criteria} = this.state;

        this.service
            .getPrepaidIcomeList(criteria)
            .then((data) => {
                if (this._isMounted) {
                    this.setState(
                        {
                            list: this.updateListElements(data.content),
                            loading: false,
                            size: data.totalElements,
                        },
                        () => this.onAfterGetList()
                    );
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState(
                        {
                            list: [],
                            loading: false,
                            size: 0,
                        },
                        () => {
                            this.afterGetListError();
                        }
                    );
                }
            });
    }

    getListTitle() {
        const {t} = this.props;
        return t('incomeList.listTitle');
    }

    updateSearchCriteria(criteria) {
        return {
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }
    renderFilter() {
        return null;
    }
    getCleanSearchCriteria() {
        return {
            firstResult: 0,
            maxResults: 10,
            sortField: undefined,
            sortAsc: false,
        };
    }
    getDataKey() {
        return 'documentNumber';
    }

    getCriteriaName() {
        return 'prepaid-balance-list-sc';
    }

    getContainerListName() {
        return 'prepaid-balance-list-container';
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderCriteria() {
        return null;
    }

    prepareColumns() {
        const {t} = this.props;
        const columns = [
            {
                field: 'date',
                header: t('incomeList.date'),
                body: this.dateTemplate.bind(this, 'date', 'DD-MM-YYYY'),
                sortable: false,
            },
            {
                field: 'amount',
                header: t('incomeList.amount'),
                body: this.amountTemplate.bind(this, 'amount'),
                sortable: false,
            },
        ];
        return columns;
    }

    prepareHeaderItems() {
        return [
            {type: 'LABEL', className: 'float-left'},
            {
                type: 'BUTTON',
                className: 'right-side',
                variant: 'white',
                disabled: !this.state.selectedList || this.state.selectedList.length < 1,
                customRenderFunction: this.renderPrintButton,
            },
        ];
    }

    render() {
        return <div className='container-fluid prepaid-balance-list-container'>{this.renderView()}</div>;
    }
    amountFormat(withCurrency, rowData) {
        const {t} = this.props;
        let result = rowData.amount?.toFixed(2);

        if (isNaN(result)) {
            result = 0;
            result = result.toFixed(2);
        }
        return !!withCurrency ? `${result} ${t('currency.pln')}` : parseFloat(result);
    }

    amountTemplate(field, rowData) {
        return (
            <span className='invoice-amount-container'>
                <span className='invoice-amount'>
                    <NumberFormat
                        value={field ? rowData[field] : rowData}
                        displayType={'text'}
                        thousandSeparator=' '
                        decimalSeparator=','
                        fixedDecimalScale
                        decimalScale={2}
                        renderText={(value) => value}
                    />
                </span>
            </span>
        );
    }

    generateReport(format) {
        const {t} = this.props;
        const list = this.state.selectedList;
        if (format === 'csv') {
            const fields = [
                {value: this.dateTemplate.bind(this, 'date', 'DD-MM-YYYY'), label: t('incomeList.date')},
                {value: this.amountFormat.bind(this, false), label: t('incomeList.amount')},
            ];
            return Promise.resolve(baseReportCsv(list, fields));
        }
        const columns = [
            {header: t('incomeList.date'), field: 'date', getColFunction: this.dateTemplate.bind(this, 'date', 'DD-MM-YYYY')},
            {header: t('incomeList.amount'), field: 'amount', getColFunction: format === 'pdf' ? this.amountFormat.bind(this, true) : null},
        ];
        if (format === 'pdf') {
            const blob = baseReportPdf({list, title: t(this.getListTitle()), columns, landscape: true}, this.props.t);
            return Promise.resolve(blob);
        } else if (format === 'xlsx' || format === 'ods') {
            const request = {};
            request.columns = columns;
            request.list = list;
            request.sheetName = t(this.getListTitle()).replaceAll(/[*?\][\\/]/g, ' ,');
            return baseXLSXReport(request, format);
        }
    }
    renderView() {
        return (
            <DivContainer colClass=''>
                <BlockUi
                    tag='div'
                    blocking={this.state.blocking || this.state.loading}
                    loader={this.loader}
                    rendered={!this.props.embedded}
                >
                    <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} rendered={!this.props.embedded} />
                    <Card
                        className='list-card'
                        // header={this.renderHeader()}
                    >
                        <DivContainer colClass='row'>{this.renderHeader()}</DivContainer>
                        {this.renderDataTable(this.prepareColumns())}
                    </Card>
                </BlockUi>
            </DivContainer>
        );
    }
}

IncomeListContainer.defaultProps = {
    lazy: false,
    disableSelection: false,
    selectionMode: 'multiple',
};

IncomeListContainer.propTypes = {};

export default withTranslation()(IncomeListContainer);
